import {
  all,
  takeEvery,
  fork,
  debounce,
  actionChannel,
  take,
  call,
  takeLatest,
} from 'redux-saga/effects';
import actions from './actions';
import { loadFileListWorker } from './workers/loadFileListWorker';
import { onPusherFileCreatedWorker } from './workers/onPusherFileCreatedWorker';
import { onPusherFileUpdatedWorker } from './workers/onPusherFileUpdatedWorker';
import { loadFilesRelationsWorker } from './workers/loadFilesRelations';
import { loadAircraftLogs } from './workers/loadAircraftLogs';
import { handleFiltersChange } from './workers/handleFiltersChange';
import { uploadFileWorker } from './workers/uploadFileWorker';
import { deleteFileWorker } from './workers/deleteFileWorker';
import { bulkDeleteFilesWorker } from './workers/bulkDeleteFilesWorker';
import { onPusherFileDeletedWorker } from './workers/onPusherFileDeletedWorker';
import { loadMoreWorker } from './workers/loadMoreWorker';
import { resetCompanyLibraryState } from './workers/resetCompanyLibraryState';
import { loadFileFromLinkWorker } from './workers/loadFileFromLinkWorker';

function* uploadFileQueueWorker() {
  const channel = yield actionChannel(actions.UPLOAD_FILE);
  while (true) {
    const action = yield take(channel);
    yield call(uploadFileWorker, action);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_FILE_LIST, loadFileListWorker),
    takeEvery(actions.LOAD_AIRCRAFT_LOGS_FOR_SELECTOR, loadAircraftLogs),
    takeEvery(actions.LOAD_FILE_LIST, loadFilesRelationsWorker),
    takeEvery(actions.PUSHER_FILE_CREATED, onPusherFileCreatedWorker),
    takeEvery(actions.PUSHER_FILE_UPDATED, onPusherFileUpdatedWorker),
    takeEvery(actions.PUSHER_FILE_DELETED, onPusherFileDeletedWorker),
    takeEvery(actions.RELATED_ENTITIES_CHANGE_FILTER, handleFiltersChange),
    debounce(700, actions.FILE_NAME_CHANGE_FILTER, handleFiltersChange),
    takeEvery(actions.RELATED_ENTITY_TYPES_CHANGE_FILTER, handleFiltersChange),
    fork(uploadFileQueueWorker),
    takeEvery(actions.DELETE_FILE, deleteFileWorker),
    takeEvery(actions.BULK_DELETE_FILES, bulkDeleteFilesWorker),
    takeEvery(actions.LOAD_MORE, loadMoreWorker),
    takeEvery(actions.RESET_STATE, resetCompanyLibraryState),
    takeLatest(actions.LOAD_FILE_FROM_LINK, loadFileFromLinkWorker),
  ]);
}
